import React from "react";
import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";

interface IconcsCardProps {
  icon: string;
  label: string;
  index?: number;
}

// Card animation variants
const cardVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.8 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.5 },
  },
  hover: {
    scale: 1.05,
    y: -8,
    transition: { duration: 0.3 },
  },
};

const IconcsCard: React.FC<IconcsCardProps> = ({ icon, label, index = 0 }) => {
  return (
    <motion.div
      className="group relative bg-white dark:bg-neutral-800 rounded-3xl p-6 transition-all duration-500 transform border border-neutral-200 dark:border-neutral-700 hover:shadow-2xl overflow-hidden"
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      transition={{ delay: index * 0.1 }}
    >
      {/* Background Gradient Effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-pink-50/50 to-rose-50/50 dark:from-pink-900/10 dark:to-rose-900/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

      {/* Decorative Elements */}
      <div className="absolute -top-2 -right-2 w-6 h-6 bg-pink-500/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <FaStar className="w-3 h-3 text-pink-500 m-1.5" />
      </div>

      {/* Icon Container */}
      <div className="relative mb-4">
        <div className="w-16 h-16 mx-auto bg-gradient-to-br from-pink-100 to-rose-100 dark:from-pink-900/30 dark:to-rose-900/30 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <img
            className="w-10 h-10 object-contain filter group-hover:brightness-110 transition-all duration-300"
            src={icon}
            alt={label}
          />
        </div>
      </div>

      {/* Label */}
      <div className="relative text-center">
        <p className="text-sm font-semibold text-neutral-800 dark:text-neutral-200 group-hover:text-pink-600 transition-colors duration-300 leading-relaxed">
          {label}
        </p>
      </div>

      {/* Hover Border Effect */}
      <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-pink-500/30 transition-colors duration-500"></div>
    </motion.div>
  );
};

export default IconcsCard;
export type { IconcsCardProps };
